class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        // Horizontal Header Tabs
        this.tab = this.querySelectorAll('.tab-title');
        // Main Contents Wrapper & Individual Tab Contents
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        // Accordion Header Links
        this.link = this.querySelectorAll('.toggleLink');
        // Read More Buttons & Close Icons
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'popup';

        // 1. Horizontal Top Tabs Event Listeners
        this.tab.forEach(tabEl => {
            tabEl.addEventListener('click', this.tabActive.bind(this));
        });

        // 2. Accordion / Toggle Links Event Listeners
        this.link.forEach(linkEl => {
            linkEl.addEventListener('click', this.accordionActive.bind(this));
        });

        // 3. Read More / Show More Event Listeners
        this.readMore.forEach(btn => {
            btn.addEventListener('click', this.readMoreReadLess.bind(this));
        });

        // 4. Tab Close Event Listeners (Popup / Mobile view)
        this.tabClose.forEach(closeBtn => {
            closeBtn.addEventListener('click', this.productTabClose.bind(this));
        });

        if (this.isVerticalPopup) {
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
            document.querySelectorAll('.pdViewTab-close').forEach(closeIcon => {
                closeIcon.addEventListener('click', this.handleVerticalPopupClose.bind(this));
            });
        }
    }

    connectedCallback() {
        // Automatically open the first tab on load if none is currently active
        const activeTab = this.querySelector('.tab-title.is-open, .toggleLink.is-open');
        if (!activeTab) {
            if (this.tab.length > 0) {
                this.activateById(this.tab[0].getAttribute('href').replace('#', ''));
            } else if (this.link.length > 0) {
                const id = this.link[0].getAttribute('href').replace('#', '').replace('-mobile', '');
                this.activateById(id);
            }
        }
    }

    // Helper Method: Direct Activation by Tab ID
    activateById(id) {
        if (!id) return;

        // Reset all buttons & content blocks
        this.tab.forEach(el => el.classList.remove('is-open'));
        this.link.forEach(el => el.classList.remove('is-open'));
        this.tabContent.forEach(element => {
            element.classList.remove('is-active', 'is-show');
            element.style.display = 'none';
        });

        // Active header tab matching ID
        const activeHeader = this.querySelector(`.tab-title[href="#${id}"]`);
        activeHeader?.classList.add('is-open');

        // Active link matching ID
        const activeLink = this.querySelector(`.toggleLink[href="#${id}"], .toggleLink[href="#${id}-mobile"]`);
        activeLink?.classList.add('is-open');

        // Show target content container
        const targetContent = this.querySelector(`#${id}`);
        if (targetContent) {
            targetContent.classList.add('is-active', 'is-show');
            targetContent.style.display = 'block';
        }

        this.checkTabShowMore(id);
    }

    // Handles Horizontal Top Tab Clicks
    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.currentTarget;
        const id = $this.getAttribute('href').replace('#', '');
        
        this.activateById(id);
    }

    // Handles Accordion / Vertical Header Clicks
    accordionActive(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.currentTarget;
        const id = $this.getAttribute('href').replace('#', '').replace('-mobile', '');

        this.activateById(id);
    }

    // Handles Read More / Read Less Toggle
    readMoreReadLess(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.currentTarget;
        const id = $this.getAttribute('href').replace('#', '').replace('-mobile', '');
        const textShowMore = $this.getAttribute('data-show-more-text');
        const textShowLess = $this.getAttribute('data-show-less-text');
        const showMoreWrap = $this.closest('.tab-showMore');
        const desMax = showMoreWrap?.dataset.desMax;
        const targetContent = this.querySelector(`#${id}`);

        if ($this.classList.contains('is-less')) {
            showMoreWrap?.classList.remove('is-less');
            $this.classList.remove('is-less');
            showMoreWrap?.classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            
            if (targetContent && desMax) {
                targetContent.style.maxHeight = `${desMax}px`;
                targetContent.style.overflow = 'hidden';
            }
            this.tabContents?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        } else {
            showMoreWrap?.classList.remove('is-show');
            $this.classList.remove('is-show');
            showMoreWrap?.classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            
            if (targetContent) {
                targetContent.style.maxHeight = 'none';
                targetContent.style.overflow = 'visible';
            }
        }
    }

    // Close Action for Mobile/Popup mode
    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents?.classList.remove('is-show');
        this.tab.forEach(el => el.classList.remove('is-open'));
        this.link.forEach(el => el.classList.remove('is-open'));

        this.tabContent.forEach(element => {
            element.classList.remove('is-active', 'is-show');
            element.style.display = 'none';
        });

        document.body.classList.remove('tab-popup-show');
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            const $thisContent = this.querySelector(`#${id}`);
            if (!$thisContent) return;
            const tabHeight = $thisContent.offsetHeight;
            const showMoreEl = $thisContent.querySelector('.tab-showMore');
            const maxHeight = parseInt(showMoreEl?.dataset.desMax || 0);

            if (maxHeight && tabHeight < maxHeight) {
                showMoreEl?.remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (window.innerWidth <= 551) return;
        if (event.target.closest('.tab-content.popup-mobile.is-show') != null) return; 
        
        this.tab.forEach(el => el.classList.remove('is-open'));
        this.link.forEach(el => el.classList.remove('is-open'));
        this.tabContent.forEach(element => {
            element.classList.remove('is-active', 'is-show');
            element.style.display = 'none';
        });
        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event) {
        const icon = event.target;
        const parentContent = icon.closest('.tab-content');
        if (parentContent) {
            parentContent.classList.remove('is-show', 'is-active');
            parentContent.style.display = 'none';
        }
        document.body.classList.remove('tab-popup-show');
    }
}

// Custom Element definition
if (!customElements.get('product-tab')) {
    customElements.define('product-tab', ProductTabs);
}